import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';

export const ProductsForYou = () => {

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4, // Número de elementos visibles por slide
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2.5,
          initialSlide: 2.5,
        },
      },
      {
        breakpoint: 393,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
    ],
  };


  return (
    <div className="pd-for-you font-family-montserrat">
      <div className="txt-center padding-categories-titles pd-you">
        <div className="txt-semibold font18">
          Los productos ideales para ti
        </div>
      </div>

      <div className="margin-lr flex-container-wrap container-100">


        <div className='box-foryou position-relative container-100'>
          <Link>
            <h3 className='position-absolute txt-foryou container-100 txt-center font800
                          color-blanco'>
              PARA ESTUDIAR
            </h3>
            <img
              src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=imagen-estudiarxs.png&version_id=null"
              alt="imagen estudiar"
              className="img-responsive mgb177 br9 pointer"
            />
          </Link>
        </div>

        <div className='box-foryou position-relative container-100'>
          <Link>
            <h3 className='position-absolute txt-foryou container-100 txt-center font800
                          color-blanco'>
              PARA TRABAJAR
            </h3>
            <img
              src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=imagen-trabajarxs.png&version_id=null"
              alt="imagen trabajar"
              className="img-responsive mgb177 br9 pointer"
            />
          </Link>
        </div>

        <div className='box-foryou position-relative container-100'>
          <Link>
            <h3 className='position-absolute txt-foryou container-100 txt-center font800
                          color-blanco'>
              COMUNIDAD GAMER
            </h3>
            <img
              src="https://compuredstore.com/minio/api/v1/buckets/web/objects/download?preview=true&prefix=comunidad-gamerxs.png&version_id=null"
              alt="imagen comunidad gamer"
              className="img-responsive mgb177 br9 pointer"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};